<template>
    <div class="form-group form-group-1">
        <label for="" class="form-label">{{ label }}</label>
        <input
            type="text"
            class="form-control"
            v-model="searchedValue"
            placeholder="Enter name (min 3 characters)"
            @input="handleSearch"
        >
        <ul
            v-show="showResults"
            class="search-results"
        >
            <li
                v-for="item in listOfItems"
                :key="item.id"
                @click="selectResult(item)"
            >
                {{ item.name }} {{ item.last_name }}
            </li>
        </ul>
    </div>
</template>


<script>
import CommonService from "../../../app/Modules/AppUser/resources/js/services/CommonService";
import _ from "lodash";
import ApplicantsServices from "../../../app/Modules/Applicants/resources/js/services/ApplicantsServices";

export default {
    name: "CommonSearch",
    props: {
        label: String,
        selectedItem: Number,
        type: String,
    },
    emits: ['update-info'],
    data() {
        return {
            listOfItems: [],
            searchedValue: null,
            showResults: false,
            filteredData: []
        }
    },
    methods: {
        delayedSearch: _.debounce(function() {
            this.getListOfItems()
        }, 500),

        handleSearch() {
            this.delayedSearch();
        },
        selectResult(result) {
            this.showResults = false
            if (this.type === 'applicant') {
                this.searchedValue = `${result.name} ${result.last_name}`
            } else {
                this.searchedValue = `${result.name}`
            }
            this.$emit('update-info', result.id)
        },
        async getListOfItems() {
            if (this.searchedValue.length < 3) {
                this.showResults = false;
                return;
            }

            try {
                const {data: response} = await CommonService.searchApplicant(this.searchedValue);
                this.listOfItems = response;
                if (this.listOfItems.length > 0) {
                    this.showResults = true;
                }
            } catch (e) {
                console.error(e);
            }
        },

        async getApplicantInfo() {
            try {
                const { data: response } = await ApplicantsServices.getUserInfo(this.selectedItem)
                this.searchedValue = `${response.name} ${response.last_name ?? ''}`
            } catch (e){
            }
        },

    },
    mounted() {
        if (this.selectedItem) {
            this.getApplicantInfo()
        }
    },
}

</script>

<style scoped>
.search-results {
    list-style: none;
    margin: 0;
    padding: 0;
    width: 100%;
    background-color: #fff;
    border: 1px solid #ddd;
    border-top: none;
    z-index: 9999;
    border-radius: 5px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    max-height: 120px;
    overflow-y: auto;
}

.search-results li {
    border-bottom: 1px solid #ddd;
    padding: 10px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.search-results li:hover {
    background-color: #0d2d53;
    color: white;
    border-radius: 5px;

}

</style>
